/** Fired when an administration form has saved a branch's setup or a profile; a save is live. */
export const SETUP_CHANGED = 'qms:setup-changed'

export function setupChanged(): CustomEvent {
  return new CustomEvent(SETUP_CHANGED)
}
